import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import HeaderOrg from "../../../Headers/HeaderOrg";
import Help from "../../../../Components/Help/Help";
import Loader from "../../../../Components/Loader/Loader";
import { serviceConsumer } from "../../../../network/ServiceConsumer";
import ManageTitle from "../../../../Components/TitleElements/ManageTitle";
import Button from "../../../../Components/Button/Button";
import { ShowToastMessage } from "../../../../helper/ShowToastMessage";

// Now / Next stage signs (card 0459db1d): one landscape page per competition,
// NOW or NEXT over the code in very large type. Stage staff keep them in plastic
// covers on an easel and flip them through the day. Each stage prints a NOW
// stack, then a NEXT stack, in the schedule's running order. They are emailed
// to the signed-in organizer, one PDF per stage (Devin 2026-11-02).
export const signsUrl = (base, eventId, stage) =>
  stage === eventId
    ? `${base}/feis/now-next-signs/email?eventId=${encodeURIComponent(eventId)}`
    : `${base}/feis/now-next-signs/email?stageId=${encodeURIComponent(stage)}`;

const NowNextSigns = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const eventId = new URLSearchParams(location.search).get("id");
  const [event, setEvent] = useState();
  const [stages, setStages] = useState([]);
  const [stage, setStage] = useState("");
  const [titleLoader, setTitleLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState("");

  useEffect(() => {
    const load = async () => {
      setTitleLoader(true);
      try {
        const eventRes = await serviceConsumer("GET", `${process.env.REACT_APP_BASE_URL}/feis/${eventId}`);
        setEvent(eventRes.Feis);
      } catch (error) {
        navigate("/pageNotFound", { replace: true });
        return;
      }
      try {
        const stageRes = await serviceConsumer(
          "GET",
          `${process.env.REACT_APP_BASE_URL}/schedule-maker/list-stages/${eventId}`
        );
        setStages(
          (stageRes?.data?.stages || []).map((item) => ({ name: item?.stageName, id: item?._id }))
        );
      } catch (error) {
        setStages([]);
      }
      setTitleLoader(false);
    };
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  const email = async () => {
    if (!stage || loading) return;
    setSent("");
    setLoading(true);
    try {
      const res = await serviceConsumer("GET", signsUrl(process.env.REACT_APP_BASE_URL, eventId, stage));
      setSent(res?.message || "Emailed");
    } catch (error) {
      ShowToastMessage("error", error?.messages || "Something went wrong", 5000);
    }
    setLoading(false);
  };

  return (
    <>
      {(loading || titleLoader) && <Loader />}
      <HeaderOrg />
      <ManageTitle
        eventLogo={event?.logo}
        eventName={event?.name}
        eventType={event?.eventType}
        eventDate={event?.feis_date}
        loading={titleLoader}
      />
      <div className="db-body">
        <div className="org-body-title pt-5">Now / Next Signs</div>
        <div className="mt-1 hr-org-body"></div>
        <p className="grey-42 mt-3 mb-0" style={{ maxWidth: 640 }}>
          One page per competition with NOW or NEXT over its code, as large as the
          page allows, for the stage easels. Each stage prints a NOW set, then a NEXT
          set, in schedule order. The signs are emailed to you, one PDF per stage.
          Print them landscape on Letter paper.
        </p>
        {!titleLoader && stages.length === 0 ? (
          <p className="mt-3">
            There is no stage schedule yet. Make one in Schedule Maker, then come back
            to print the signs.
          </p>
        ) : (
          <>
            <div className="search-label mt-3">Choose Stage:</div>
            <div className="d-flex gap-3 flex-column flex-md-row">
              <select
                name="now-next-stage"
                className="check-in-select"
                value={stage}
                onChange={(e) => {
                  setStage(e.target.value);
                  setSent("");
                }}
              >
                <option value="" hidden>
                  Select
                </option>
                <option value={eventId}>All Stages</option>
                {stages.map((s) => (
                  <option key={s.id} value={s.id}>
                    {s.name}
                  </option>
                ))}
              </select>
              <div>
                <Button className={stage ? "outlined" : "disabledOutlined"} onClick={email}>
                  Email PDFs
                </Button>
              </div>
            </div>
            {sent && <p className="mt-3 mb-0">{sent}. Check your inbox for one PDF per stage.</p>}
          </>
        )}
        <ToastContainer />
      </div>
      <Help />
    </>
  );
};

export default NowNextSigns;
